import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { CircularProgress, styled } from '@mui/material';

export const StyledGoalItemProgressWrap = styled('div')(() => ({
	background: '#FFF',
	borderRadius: '50%',
	position: 'relative',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',

	width: '40px',
	height: '40px',
}));

export const StyledGoalItemProgress = styled(CircularProgress)(() => ({
	color: '#6AD26F',

	'& circle': {
		strokeWidth: '2px',
	},

	width: '35px !important',
	height: '35px !important',
}));

export const StyledGoalItemProgressIcon = styled(CheckCircleIcon)({
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
});
